import { render, staticRenderFns } from "./CustomStyle.vue?vue&type=template&id=7b4b5f35&scoped=true&"
import script from "./CustomStyle.vue?vue&type=script&lang=js&"
export * from "./CustomStyle.vue?vue&type=script&lang=js&"
import style0 from "./CustomStyle.vue?vue&type=style&index=0&id=7b4b5f35&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4b5f35",
  null
  
)

export default component.exports